"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataCardInput = void 0;
var React = require("react");
var DataCard_1 = require("./DataCard");
var TextField_1 = require("../TextField");
var Dropdown_1 = require("../Dropdown");
var moment = require("moment");
var DatetimePicker_1 = require("../DatetimePicker");
var theme_1 = require("../../theme");
var styled_components_1 = require("styled-components");
var semantic_ui_react_1 = require("semantic-ui-react");
var DataCardInput = /** @class */ (function (_super) {
    __extends(DataCardInput, _super);
    function DataCardInput(props) {
        var _this = _super.call(this, props) || this;
        _this.getInputWidth = function () {
            return _this.props.isInline ? '95%' : '90%';
        };
        return _this;
    }
    DataCardInput.prototype.renderTextField = function () {
        var _a = this.props, value = _a.value, onInputChanged = _a.onInputChanged;
        return (React.createElement(TextField_1.TextField, { fontWeight: this.props.isInline ? 'bold' : undefined, fontSize: this.props.isInline ? '1.1667rem' : undefined, isInline: this.props.isInline, style: { width: this.getInputWidth() }, name: value.fieldName, value: value.value, onChange: function (e) {
                return onInputChanged(value.fieldName, e.target.value);
            } }));
    };
    DataCardInput.prototype.renderNumberField = function () {
        var _a = this.props, value = _a.value, onInputChanged = _a.onInputChanged;
        return (React.createElement(TextField_1.TextField, { fontWeight: this.props.isInline ? 'bold' : undefined, fontSize: this.props.isInline ? '1.1667rem' : undefined, isInline: this.props.isInline, style: { width: this.getInputWidth() }, name: value.fieldName, value: value.value, type: "number", onChange: function (e) {
                return onInputChanged(value.fieldName, e.target.value);
            } }));
    };
    DataCardInput.prototype.renderDateField = function () {
        var _a = this.props, value = _a.value, onInputChanged = _a.onInputChanged;
        return (React.createElement(DatetimePicker_1.DatetimePicker, { isInline: this.props.isInline, onChange: function (date) {
                onInputChanged(value.fieldName, date ? date.toISOString() : null);
            }, selected: value.value ? moment(value.value) : undefined }));
    };
    DataCardInput.prototype.renderDateTimeField = function () {
        var _a = this.props, value = _a.value, onInputChanged = _a.onInputChanged;
        return (React.createElement(DatetimePicker_1.DatetimePicker, { isInline: this.props.isInline, includeTime: true, onChange: function (date) {
                onInputChanged(value.fieldName, date ? date.toISOString() : null);
            }, selected: value.value ? moment(value.value) : undefined }));
    };
    DataCardInput.prototype.getCheckboxStyle = function () {
        return this.props.isInline && { border: '2px solid black !important' };
    };
    DataCardInput.prototype.renderCheckbox = function () {
        var _a = this.props, value = _a.value, onInputChanged = _a.onInputChanged, isInline = _a.isInline;
        return (React.createElement(CheckboxWrapper, { isInline: isInline },
            React.createElement(semantic_ui_react_1.Checkbox, { checked: value.value === 'true' ? true : false, onChange: function (_, checkValue) {
                    onInputChanged(value.fieldName, checkValue.checked ? 'true' : 'false');
                } })));
    };
    DataCardInput.prototype.renderPickList = function () {
        var _a = this.props, value = _a.value, onInputChanged = _a.onInputChanged, isInline = _a.isInline, addUndefinedOption = _a.addUndefinedOption;
        return !isInline ? (React.createElement(semantic_ui_react_1.Dropdown, { placeholder: 'Select', options: value.pickListOptions, value: value.value, multiple: value.isPickListMulti, selection: true, search: true, onChange: function (_e, data) {
                onInputChanged(value.fieldName, data.value ? data.value : null);
            } })) : (React.createElement(Dropdown_1.Dropdown, { addUndefinedOption: addUndefinedOption, isInline: true, placeholder: 'Select', options: value.pickListOptions, value: value.value, multiple: value.isPickListMulti, selection: true, search: true, onChange: function (_e, data) {
                onInputChanged(value.fieldName, data.value ? data.value : null);
            } }));
    };
    DataCardInput.prototype.render = function () {
        var value = this.props.value;
        switch (value.dataType) {
            case DataCard_1.DataType.Text:
            case DataCard_1.DataType.Hyperlink:
                return this.renderTextField();
            case DataCard_1.DataType.Number:
                return this.renderNumberField();
            case DataCard_1.DataType.Date:
                return this.renderDateField();
            case DataCard_1.DataType['Date/Time']:
                return this.renderDateTimeField();
            case DataCard_1.DataType['True/False']:
                return this.renderCheckbox();
            case DataCard_1.DataType['Pick List']:
                return this.renderPickList();
            default:
                return React.createElement("div", null, "--");
        }
    };
    return DataCardInput;
}(React.Component));
exports.DataCardInput = DataCardInput;
var CheckboxWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .checkbox {\n    label {\n      margin-left: ", ";\n      &::before {\n        border: ", " !important;\n      }\n    }\n  }\n"], ["\n  & .checkbox {\n    label {\n      margin-left: ", ";\n      &::before {\n        border: ",
    " !important;\n      }\n    }\n  }\n"])), function (props) { return props.isInline && '1rem'; }, function (props) {
    return props.isInline && "2px solid " + theme_1.colors.black25;
});
var templateObject_1;
//# sourceMappingURL=DataCardInput.js.map